import styled from 'styled-components';
import { customMedia } from 'styles/utils';

const breakpoint = 'medium';

export const SampleBannerWrapper = styled.section`
  position: relative;
  display: flex;
  flex-direction: column;
  box-shadow: rgb(67 90 111 / 42%) 0 0 1px, rgb(67 90 111 / 30%) 0 5px 8px -4px;
  border: 1px solid ${props => props.theme.color.wfGrey500};
  max-width: 48rem;
  margin: ${props => props.theme.spacing.default} 0;
  padding: ${props => props.theme.spacing.default};

  ${customMedia.lessThan(breakpoint)`
    max-width: 72vw;
  `}
`;

export const HeaderRowWrapper = styled.div`
  display: flex;
  margin-right: ${props => props.theme.spacing.xxxlarge};
  margin-bottom: ${props => props.theme.spacing.default};

  ${customMedia.lessThan(breakpoint)`
    flex-direction: column;

    h5 {
      margin: ${props => props.theme.spacing.small} 0;
    }
  `}
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;

  ${customMedia.lessThan(breakpoint)`
    flex-direction: column;
  `}
`;

export const CloseButtonWrapper = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: ${props => props.theme.spacing.small};
`;
